var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOwnerOccupiedRealEstate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.01953 13.43V47.15C4.01953 49.28 5.73953 51 7.86953 51H39.1795C41.3095 51 43.0295 49.28 43.0295 47.15V13.43C43.0295 11.3 41.3095 9.57996 39.1795 9.57996H7.86953C5.73953 9.57996 4.01953 11.31 4.01953 13.43Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01953 13.44V47.14C4.01953 49.27 5.74953 51 7.87953 51H39.1795C41.3095 51 43.0395 49.27 43.0395 47.14V13.44C43.0395 11.31 41.3095 9.57996 39.1795 9.57996H7.86953C5.73953 9.57996 4.01953 11.31 4.01953 13.44Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5091 33.99H23.5191V51H14.0391V35.45C14.0391 34.64 14.6991 33.99 15.5091 33.99Z",
    fill: "#FFCF00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5393 33.99H23.5293V51H32.9993V35.45C32.9993 34.64 32.3493 33.99 31.5393 33.99Z",
    fill: "#FFCF00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5091 33.99H23.5191V51H14.0391V35.45C14.0391 34.64 14.6991 33.99 15.5091 33.99Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5393 33.99H23.5293V51H32.9993V35.45C32.9993 34.64 32.3493 33.99 31.5393 33.99Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2798 27.6899H11.5898",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2798 21.9399H11.5898",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2798 16.2H11.5898",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7695 27.6899H35.4495",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7695 21.9399H35.4495",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0589 22.86C43.0954 22.86 47.9889 17.9665 47.9889 11.93C47.9889 5.89353 43.0954 1 37.0589 1C31.0224 1 26.1289 5.89353 26.1289 11.93C26.1289 17.9665 31.0224 22.86 37.0589 22.86Z",
    fill: "#FFCF00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6601 17.23L39.7801 19.83L40.8901 21.24L42.4501 22.38L37.1701 23.49L32.3301 22.28L33.2201 21.42L34.5601 19.17L34.4701 17.49L36.4501 18.41L38.0001 18.07L39.6601 17.23Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0589 22.86C43.0954 22.86 47.9889 17.9665 47.9889 11.93C47.9889 5.89353 43.0954 1 37.0589 1C31.0224 1 26.1289 5.89353 26.1289 11.93C26.1289 17.9665 31.0224 22.86 37.0589 22.86Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3588 9.73998C31.4288 9.73998 31.4888 9.74998 31.5588 9.74998C31.7188 6.53998 34.1188 4.59998 37.0588 4.59998C39.9988 4.59998 42.3988 6.53998 42.5588 9.74998C42.6188 9.73998 42.6888 9.73998 42.7588 9.73998C43.6188 9.73998 44.3188 10.44 44.3188 11.3C44.3188 12.16 43.6188 12.86 42.7588 12.86C42.5488 12.86 42.3488 12.82 42.1688 12.74C41.3488 15.61 39.3788 18.46 37.0688 18.46C34.7588 18.46 32.7888 15.61 31.9688 12.74C31.7888 12.81 31.5888 12.86 31.3788 12.86C30.5188 12.86 29.8188 12.16 29.8188 11.3C29.7988 10.44 30.4988 9.73998 31.3588 9.73998Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3588 9.73998C31.4288 9.73998 31.4888 9.74998 31.5588 9.74998C31.7188 6.53998 34.1188 4.59998 37.0588 4.59998C39.9988 4.59998 42.3988 6.53998 42.5588 9.74998C42.6188 9.73998 42.6888 9.73998 42.7588 9.73998C43.6188 9.73998 44.3188 10.44 44.3188 11.3C44.3188 12.16 43.6188 12.86 42.7588 12.86C42.5488 12.86 42.3488 12.82 42.1688 12.74C41.3488 15.61 39.3788 18.46 37.0688 18.46C34.7588 18.46 32.7888 15.61 31.9688 12.74C31.7888 12.81 31.5888 12.86 31.3788 12.86C30.5188 12.86 29.8188 12.16 29.8188 11.3C29.7988 10.44 30.4988 9.73998 31.3588 9.73998Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7793 17.12V19.68C39.7793 20.73 40.6293 21.58 41.6793 21.58H42.0193",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7491 9.73998C42.6791 9.73998 42.6191 9.74998 42.5491 9.74998C42.3891 6.53998 39.9891 4.59998 37.0491 4.59998C34.1091 4.59998 31.7091 6.53998 31.5491 9.74998C31.4891 9.73998 31.4191 9.73998 31.3491 9.73998C30.4891 9.73998 29.7891 10.44 29.7891 11.3C29.7891 12.16 30.4891 12.86 31.3491 12.86C31.5591 12.86 31.7591 12.82 31.9391 12.74C32.7591 15.61 34.7291 18.46 37.0391 18.46C39.3491 18.46 41.3191 15.61 42.1391 12.74C42.3191 12.81 42.5191 12.86 42.7291 12.86C43.5891 12.86 44.2891 12.16 44.2891 11.3C44.3091 10.44 43.6091 9.73998 42.7491 9.73998Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7491 9.73998C42.6791 9.73998 42.6191 9.74998 42.5491 9.74998C42.3891 6.53998 39.9891 4.59998 37.0491 4.59998C34.1091 4.59998 31.7091 6.53998 31.5491 9.74998C31.4891 9.73998 31.4191 9.73998 31.3491 9.73998C30.4891 9.73998 29.7891 10.44 29.7891 11.3C29.7891 12.16 30.4891 12.86 31.3491 12.86C31.5591 12.86 31.7591 12.82 31.9391 12.74C32.7591 15.61 34.7291 18.46 37.0391 18.46C39.3491 18.46 41.3191 15.61 42.1391 12.74C42.3191 12.81 42.5191 12.86 42.7291 12.86C43.5891 12.86 44.2891 12.16 44.2891 11.3C44.3091 10.44 43.6091 9.73998 42.7491 9.73998Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3396 17.12V19.68C34.3396 20.73 33.4896 21.58 32.4396 21.58H32.0996",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnerOccupiedRealEstate);
export default __webpack_public_path__ + "static/media/OwnerOccupiedRealEstate.e15794dbd36ef8acda658db0d421fd5b.svg";
export { ForwardRef as ReactComponent };